module.exports = __webpack_public_path__ + "static/media/diners-club-logo.618b5982.png";